import { render, staticRenderFns } from "./gj-vxe-table.vue?vue&type=template&id=78d1654c&scoped=true&"
import script from "./gj-vxe-table.vue?vue&type=script&lang=js&"
export * from "./gj-vxe-table.vue?vue&type=script&lang=js&"
import style0 from "./gj-vxe-table.vue?vue&type=style&index=0&id=78d1654c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d1654c",
  null
  
)

export default component.exports